import React from 'react';
import TextFilter from './TextFilter';
import SelectFilter from './SelectFilter';
import { Form, Button, Container, Row, Col } from 'react-bootstrap'
import { minusIcon, filterIcon } from "../../../img/font_awesome/font_awesome";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
	return {
		bookLabel: state.countyConfigCommonReducer.bookLabel
	};
}

class PageBanner extends React.Component {
   render() {

      let textFilterComponent = '';
      if (this.props.selectFilterProps) {
         textFilterComponent =  <span style={{ display:'inline-block', marginLeft: 30, verticalAlign: 'middle'}}><TextFilter textFilterProps={this.props.textFilterProps}></TextFilter></span>
      }

      let selectFilterComponent = '';
      if (this.props.selectFilterProps) {
         selectFilterComponent = <span style={{ display:'inline-block', marginLeft: 30, verticalAlign: 'middle' }}><SelectFilter selectFilterProps={this.props.selectFilterProps}></SelectFilter></span>
      }

      let finderFilterComponent = '';
      if (this.props.finderFilterProps && this.props.finderFilterProps.id > 0) {
         finderFilterComponent =<><span> <Button variant="secondary" onClick={this.props.finderFilterProps.finderFilterReset}>{minusIcon} Account: {this.props.finderFilterProps.name}</Button></span></>   
      } else if (this.props.finderFilterProps) {
         finderFilterComponent = <span style={{ display:'inline-block', marginLeft: 30, verticalAlign: 'middle' }}>
            <Container>
               <Row>
                  <Col><Button variant='primary' onClick={this.props.finderFilterProps.finderFilterClick}>Account {filterIcon}</Button></Col>
               </Row>
            </Container>
         </span> 
      }



      let criteriaList = '';
      if (this.props.searchCriteria) {
         criteriaList = this.props.searchCriteria.map(criteria => {
            let criteriaValue = criteria.value === 'true' ? 'Yes' : criteria.value ;
            let criteriaDesc = criteria.description;
            if (criteriaDesc === 'Book'){
               criteriaDesc = this.props.bookLabel;
            } else if(criteriaDesc === 'Book Type'){
               criteriaDesc = this.props.bookLabel + ' Type';
            }
            return <ul style={{ display: 'inline-block', marginBottom: 0, listStyleType: 'none', paddingLeft:10, fontSize: 14 }}><li style={{ textDecoration: "underline" }} >{criteriaDesc}</li><li style={{ textAlign: "center" }}>{criteriaValue}</li></ul>
         });
      }

      let buttonList = '';
      if (this.props.buttons) {
         buttonList = this.props.buttons.map((button, description) => {
            let buttonClassName = button.className;
            if (!buttonClassName) {
               buttonClassName = "btn btn-primary";
            }
            return (<><button className={buttonClassName} onClick={button.onClickAction} >{button.icon} {button.label}</button>&nbsp;</>)
         })
      }


      let pageHeadingVal = this.props.pageHeading;
      if (pageHeadingVal === 'Search by Book and Page'){
         pageHeadingVal = 'Search by ' + this.props.bookLabel + ' and Page';
      }

      return (
         <h5 style={{ color: '#3674AB', paddingTop: 10, paddingBottom: 10, paddingLeft: 10, marginTop: 5, marginLeft:4, marginRight:4, border: '3px solid #3674AB', borderRadius: '5px' }}>
            {pageHeadingVal}
            {textFilterComponent}
            {selectFilterComponent}
            {finderFilterComponent}
            <span style={{ marginRight: 20 }}>{criteriaList}</span>
            <span style={{ float: 'right', marginRight: 10 }}>{buttonList}</span>
         </h5>
      )
   }

}


export default connect(mapStateToProps)(PageBanner);